import { CdkScrollable } from "@angular/cdk/scrolling";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";
import { NsExpWidget } from "../models/widgets.models";

export function filterOut(
  ...types: NsEmpWebExpData.IBookingStates[]
): (source: Observable<NsEmpWebExpData.IList[]>) => Observable<NsEmpWebExpData.IList[]> {
  return (source: Observable<NsEmpWebExpData.IList[]>) => {
    const removeSet = new Set(types);
    return source.pipe(map(bookings => bookings.filter(booking => !removeSet.has(booking.booking.requestStatus))));
  };
}

export function scrollDownFilter(container: CdkScrollable): <T>(source: Observable<T>) => Observable<T> {
  return <T>(source: Observable<T>) => {
    return new Observable<T>(subscriber => {
      let offset = container.measureScrollOffset("bottom");
      const subscription = source.subscribe({
        next(val) {
          const newOffset = container.measureScrollOffset("bottom");
          if (newOffset < offset) {
            subscriber.next(val);
          }
          offset = newOffset;
        },
        error(val) {
          subscriber.error(val);
        },
        complete() {
          subscriber.complete();
        }
      });
      return () => subscription.unsubscribe();
    });
  };
}

export function filterWidgetRefresh(
  ...types: NsExpWidget.TWidgetGroups[]
): (source: Observable<NsExpWidget.TWidgetGroups | undefined>) => Observable<NsExpWidget.TWidgetGroups | undefined> {
  return (source: Observable<NsExpWidget.TWidgetGroups | undefined>) => {
    return source.pipe(filter((type?: NsExpWidget.TWidgetGroups) => !type || types.includes(type)));
  };
}
